/**
 * Singleton location to store responses from remote files to diff on.
 */
define('GameDayCore/GDModel/storage/ResponseCache',['require','exports','module','extant/extant','../../GDUtil/window/Logg'],function(require,exports,module) {
    var exists = require("extant/extant"),
        logg = require("../../GDUtil/window/Logg"),
        responseHash = {};

	exports.storeResponse = function (resource, reText) {
        responseHash[resource] = { text: reText, updated: false };
    };

    exports.retrieveResponse = function (resource) {
        return responseHash[resource];
    };
    exports.responseExists = function (resource) {
        return exists(responseHash[resource]);
    };
    exports.responseHasChanged = function (resource, reText) {
        return (exists(responseHash[resource])) ? responseHash[resource].updated : false;
    };

    exports.verifyChangeAndStore = function (resource, reText) {
        if (!exists(responseHash[resource])) {
            responseHash[resource] = { text: reText, updated: true };
            return true;
        } else if (responseHash[resource].text !== reText) {
            logg.log("storing new " + resource + " cache text");

            responseHash[resource].text = reText;
            responseHash[resource].updated = true;
            return true;
        } else {
            responseHash[resource].updated = false;
            return false;
        }
    }
});
